








import FrontEdit from "@/components/products/schatzbuch/design/FrontEdit.vue"
import BackEdit from "@/components/products/schatzbuch/design/BackEdit.vue"
import InnerImage from "@/components/products/schatzbuch/design/InnerImage.vue"
import { TreasureBookModule } from '@/store/modules/treasureBook'

export default {
    name: "treasure-book-design",

    components: {
        FrontEdit,
        BackEdit,
        InnerImage
    },
    computed: {
        showDesignInnerImage: function () {
            return TreasureBookModule.showDesignInnerImage;
        },
        showDesignBack: function () {
            return TreasureBookModule.showDesignBack;
        },
        showDesignText: function () {
            return TreasureBookModule.showDesignText;
        },
        showDesignFront: function () {
            return TreasureBookModule.showDesignFront;
        }
    }
}
